module.exports = __webpack_public_path__ + "static/media/peanuts-celebration.13901822.webp";